// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Navigate } from "react-router-dom";
import { useKeycloak } from "../../context/KeycloakProvider";
import { usePermissions } from "../../hooks/usePermissions";

const ProtectedRoute = ({ children, roles = [], permissions = [] }) => {
  const { authenticated, hasRole } = useKeycloak();
  const {
    hasAnyPermission,
    loading: permissionsLoading,
    userHasRoles,
    isInitialized,
  } = usePermissions();

  // Not authenticated → send to the public landing/login. We intentionally do
  // NOT remember this path: after logout or a session expiry, the next login
  // must land on that user's own default page (getFirstAccessibleRoute), not
  // the previous session's page — otherwise a different user gets dropped onto
  // (and may lack access to) the prior user's last screen.
  if (!authenticated) {
    return <Navigate to="/" replace />;
  }

  if (!userHasRoles && isInitialized) {
    return <Navigate to="/?showPermissionPopup=true" replace />;
  }

  if (!isInitialized || permissionsLoading) {
    return null;
  }

  if (roles.length > 0 && !roles.some((role) => hasRole(role))) {
    return <Navigate to="/?showPermissionPopup=true" replace />;
  }

  if (permissions.length > 0 && !hasAnyPermission(permissions)) {
    return <Navigate to="/?showPermissionPopup=true" replace />;
  }

  return children;
};

export default ProtectedRoute;
